import { DataFile } from "./common_model";

export interface RMATracking {
    id: number;
    rma_received_date: string;
    received_express_tracking_number: string;
    end_user_contact: string;
    shipment_date: string;
    received_engraving_number: string;
    received_serial_number: string;
    warranty: string;
    spn_number: string;
    model: string;
    model_remark: string;
    defect_description: string;
    root_cause: string;
    liability: string;
    handling_method: string;
    root_cause_summary: string[];
    defect_classification: string;
    ship_out_express_tracking_number: string;
    payment_owner: string;
    repair_cost: number;
    return_engraving_number: string;
    return_serial_number: string;
    closed_date: string;
    remark: string;
    created_at: string;
    updated_at: string;
    created_by: number;
    updated_by: number;
    root_cause_files?: DataFile[];
    status: number;
    area: number;
    client_id: string;
    ean_number: string;
    delivery_date: string;
}

export const RMATrackingStatus: {[val: string]: string} = {0: 'Received', 1: 'Repaired', 2: 'Returned'}

export interface RMATrackingConfig {
    MODELS: string[],
    AVAILABLE_AREAS: number[]
}

export type FieldConfigItem = {
    label: string,
    required: number,
    options: string[],
    removed: boolean,
    multiple: boolean,
    type: string
}

export type FieldConfigs = {
    [name: string]: FieldConfigItem
}


export interface ModelData {
    id: number;
    name: string;
    description: string;
}


export interface SaleData {
    model: string;
    serial: string;
    engraved: string;
    setserial: string;
    spn: string;
    ean: string;
    delivery_date: string;
    customer_id: string;
    delivery_note: string;
    item: string;
    qty: number;
    remarks: string;
    supplier_number: string;
    supplier_name: string;
    order_number: string;
    notice_no: string;
    warehousing_order_nr: string;
    storage_date: string;
    material_number: string;
    sku: string;
    unit: string;
    box_barcode: string;
    barcode_type: string;
    storage_type: string;
    warehouse_number: string;
    warehouse_name: string;
    data_source: string;
    budget_code: string;
    title?: string;
}

export interface CommonEnumData {
    id: number;
    name: string;
    description: string;
    cn_name?: string;
    cn_description?: string;
}